import { REDIRECT_URL } from '@modules/common/constants';
import { UUID } from 'v2/core/entities/uuid';

export const KEYWORD_SUMMARY_REDIRECTION_TAG =
  'keyword_summary_link_clicked_from_record';

export const getURLForRedirectionThroughEnterpret = (
  redirectTo: string,
  tenantName: string,
  tenantID: UUID,
  tag: string,
) => {
  const url = new URL(REDIRECT_URL);

  url.searchParams.set('redirectTo', redirectTo);
  url.searchParams.set('tenant', tenantName);
  url.searchParams.set('tenantId', tenantID);
  url.searchParams.set('tag', tag);

  return url.toString();
};
